import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { Injectable } from "@angular/core";
import { UtilsService } from "src/app/core/services/utils.service";

function padNumber(value: number | null) {
  if (!isNaN(value) && value !== null) {
    return `0${value}`.slice(-2);
  } else {
    return "";
  }
}

/**
 * Custom Date Parser formatter for date field.
 */
@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {

  constructor(private utils: UtilsService) {
    super();
  }

  /**
   * Converts string to NgbDateStruct object.
   */
  parse(value: string): NgbDateStruct | null {
    return this.utils.toNgbDateStruct(value);
  }

  /**
   * Converts NgbDateStruct object to string.
   */
  format(date: NgbDateStruct | null): string {
    return date
      ? `${padNumber(date.month)}-${padNumber(date.day)}-${date.year || ""}`
      : "";
  }
}
